export default __webpack_public_path__ + "static/media/Trustage.897601c6.svg";